import { TStatusDisplayId } from "components/common/constants";

export const columnConfig = {
  //Space - 1
  1: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
    {
      title: "Space Temperature Active",
      intlId: TStatusDisplayId["SpaceTemperature"],
      type: "data"
    },
    {
      title: "Space Temperature Setpoint Active",
      intlId: TStatusDisplayId["ActiveSetpoint"],
      type: "data"
    },
    {
      title: "Variance",
      intlId: TStatusDisplayId["Variance"],
      type: "info"
    },
    {
      title: "Heat Cool Mode Status",
      intlId: TStatusDisplayId["HeatCoolMode"],
      type: "data"
    },
  ],
  // Chiller - 2
  2: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Entering Water Temperature",
      intlId: TStatusDisplayId["EnteringWaterTemperature"],
      type: "data"
    },
    {
      title: "Leaving Water Temperature",
      intlId: TStatusDisplayId["LeavingWaterTemperature"],
      type: "data"
    },
    {
      title: "Operating Mode",
      intlId: TStatusDisplayId["OperatingMode"],
      type: "data"
    },
  ],
  // Air Handler - 3
  3: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Duct Static Pressure Active",
      intlId: TStatusDisplayId["DuctStatusPressure"],
      type: "data"
    },
    {
      title: "Duct Static Pressure Setpoint Active",
      intlId: TStatusDisplayId["DuctStaticPressureStPt"],
      type: "data"
    },
    {
      title: "Discharge Air Temperature",
      intlId: TStatusDisplayId["DischargeAirTemperature"],
      type: "data"
    },
    {
      title: "Discharge Air Temperature Setpoint Active",
      intlId: TStatusDisplayId["DischargeAirTempStPt"],
      type: "data"
    },
  ],
  // Programmable Controller -4
  4: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
  ],
  // Chiller Plant - 5
  5: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "System Chilled Water Setpoint",
      intlId: TStatusDisplayId["ChilledWaterSetpoint"],
      type: "data"
    },
    {
      title: "System Chilled Water Return Temperature",
      intlId: TStatusDisplayId["ReturnWaterTemperature"],
      type: "data"
    },
    {
      title: "Supply Water Temperature",
      intlId: TStatusDisplayId["SupplyWaterTemperature"],
      type: "data"
    },
    {
      title: "Flow Status",
      intlId: TStatusDisplayId["FlowStatus"],
      type: "data"
    },
    {
      title: "Bypass Flow",
      intlId: TStatusDisplayId["BypassFlow"],
      type: "data"
    },
  ],
  // Heat Pump Loop - 6
  6: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Active Setpoint",
      intlId: TStatusDisplayId["ActiveSetpoint"],
      type: "data"
    },
    {
      title: "Return Water Temperature",
      intlId: TStatusDisplayId["ReturnWaterTemperature"],
      type: "data"
    },
    {
      title: "Supply Water Temperature",
      intlId: TStatusDisplayId["SupplyWaterTemperature"],
      type: "data"
    },
    {
      title: "Flow",
      intlId: TStatusDisplayId["Flow"],
      type: "data"
    },
    {
      title: "Heat/Cool Mode",
      intlId: TStatusDisplayId["HeatCoolMode"],
      type: "data"
    },
    {
      title: "Compressor Enabled",
      intlId: TStatusDisplayId["CompressorEnabled"],
      type: "data"
    },
  ],
  // IO - 7
  7: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
  ],
  // Building Controller - 8
  8: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
  ],
  // Variable Air - 9
  9: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Occupancy",
      intlId: TStatusDisplayId["Occupancy"],
      type: "data"
    },
    {
      title: "Operating Mode",
      intlId: TStatusDisplayId["OperatingMode"],
      type: "data"
    },
  ],
  // BACNet -10
  // Area - 11
  11: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Inside Temperature",
      intlId: TStatusDisplayId["InsideTemperature"],
      type: "data"
    },
    {
      title: "Active Setpoint",
      intlId: TStatusDisplayId["ActiveSetpoint"],
      type: "data"
    },
    {
      title: "Heat/Cool Mode",
      intlId: TStatusDisplayId["HeatCoolMode"],
      type: "data"
    },
    {
      title: "Present Value",
      intlId: TStatusDisplayId["AreaPresentValue"],
      type: "data"
    },
    {
      title: "Lighting Value",
      intlId: TStatusDisplayId["LightingValue"],
      type: "data"
    },
  ],
  // Air Handler (Evo Product) - 12
  12: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Duct Static Pressure",
      intlId: TStatusDisplayId["DuctStatusPressure"],
      type: "data"
    },
    {
      title: "Duct Static Pressure Setpoint Active",
      intlId: TStatusDisplayId["EvoDuctStaticPressureSpt"],
      type: "data"
    },
    {
      title: "Discharge Air Temperature",
      intlId: TStatusDisplayId["DischargeAirTemperature"],
      type: "data"
    },
    {
      title: "Active Discharge Air Temperature Setpoint",
      intlId: TStatusDisplayId["DischargeAirTempStPt"],
      type: "data"
    },
  ],
  //  Trim Respond In SC - 13
  13: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Operating Mode",
      intlId: TStatusDisplayId["OperatingModeTrim"],
      type: "data"
    },
    {
      title: "Trim Value",
      intlId: TStatusDisplayId["TrimValue"],
      type: "data"
    },
    {
      title: "Response Value",
      intlId: TStatusDisplayId["ResponseValue"],
      type: "data"
    },
    {
      title: "Ignored Requests Threshold",
      intlId: TStatusDisplayId["IgnoredRequests"],
      type: "data"
    },
    {
      title: "Run Mode",
      intlId: TStatusDisplayId["RunMode"],
      type: "data"
    },
  ],
  //  Meters In SC - 14
  14: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
  ],
  //  VRF Equipment (Outdoor,Branch,Remote) - 15
  15: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
    {
      title: "Communication Status",
      intlId: TStatusDisplayId["CommunicationStatus"],
      type: "data"
    },
  ],
  //  VRF Indoor Units - 16
  16: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
    {
      title: "Space Temperature Active",
      intlId: TStatusDisplayId["SpaceTemperature"],
      type: "data"
    },
    {
      title: "Active Setpoint",
      intlId: TStatusDisplayId["ActiveSetpoint"],
      type: "data"
    },
    {
      title: "VRF Heat Cool Mode Status",
      intlId: TStatusDisplayId["ModeStatus"],
      type: "data"
    },
    {
      title: "Occupancy",
      intlId: TStatusDisplayId["Occupancy"],
      type: "data"
    },
    {
      title: "Fan Speed",
      intlId: TStatusDisplayId["FanSpeed"],
      type: "data"
    },
    {
      title: "Vane Direction",
      intlId: TStatusDisplayId["VaneDirection"],
      type: "data"
    },
    {
      title: "Auto Mode Type",
      intlId: TStatusDisplayId["SetPointType"],
      type: "data"
    },
  ],
  // Area for SC - 17
  17: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Space Temperature Sensor",
      intlId: TStatusDisplayId["SpaceTemperatureSensor"],
      type: "info"
    },
    {
      title: "Active Setpoint",
      intlId: TStatusDisplayId["ActiveSetpoint"],
      type: "data"
    },
    {
      title: "Heat/Cool Mode",
      intlId: TStatusDisplayId["HeatCoolMode"],
      type: "data"
    },
    {
      title: "Present Value",
      intlId: TStatusDisplayId["AreaPresentValue"],
      type: "data"
    },
    {
      title: "Lighting Value",
      intlId: TStatusDisplayId["LightingValue"],
      type: "data"
    },
  ],
  // Support in SC - 18
  18: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
    {
      title: "Communication Status",
      intlId: TStatusDisplayId["CommunicationStatus"],
      type: "data"
    },
  ],
  // Boilers in SC - 19
  19: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Alarm Relay Output Status",
      intlId: TStatusDisplayId["AlarmRelayOutputStatus"],
      type: "data"
    },
    {
      title: "Boiler Status",
      intlId: TStatusDisplayId["BoilerStatus"],
      type: "data"
    },
    {
      title: "Boiler Enable",
      intlId: TStatusDisplayId["BoilerEnable"],
      type: "data"
    },
    {
      title: "Boiler Temperature Setpoint Active",
      intlId: TStatusDisplayId["BoilerTempSptActive"],
      type: "data"
    },
    {
      title: "Boiler Leaving Temperature",
      intlId: TStatusDisplayId["BoilerLeavingTemp"],
      type: "data"
    },
  ],
  // Plants in SC - 20
  20: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
    {
      title: "Communication Status",
      intlId: TStatusDisplayId["CommunicationStatus"],
      type: "data"
    },
  ],
  //Pivot - 21
  21: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Equipment Type",
      intlId: TStatusDisplayId["EquipmentType"],
      type: "info"
    },
    {
      title: "Space Temperature Active",
      intlId: TStatusDisplayId["SpaceTemperature"],
      type: "data"
    },
    {
      title: "Active Setpoint",
      intlId: TStatusDisplayId["ActiveSetpoint"],
      type: "data"
    },
    {
      title: "Variance",
      intlId: TStatusDisplayId["Variance"],
      type: "info"
    },
    {
      title: "Heat Cool Mode Status",
      intlId: TStatusDisplayId["HeatCoolModeStatus"],
      type: "data"
    },
  ],
  // Chiller For Lon Connected In BCU - 22
  22: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Entering Water Temperature",
      intlId: TStatusDisplayId["EnteringWaterTemperature"],
      type: "data"
    },
    {
      title: "Leaving Water Temperature",
      intlId: TStatusDisplayId["LeavingWaterTemperature"],
      type: "data"
    },
    {
      title: "Active Mode",
      intlId: TStatusDisplayId["ActiveMode"],
      type: "data"
    },
  ],
  // Chiller For Bacnet Controller In SC - 23
  23: [
    {
      title: "Name",
      intlId: TStatusDisplayId["Name"],
      type: "info"
    },
    {
      title: "Entering Water Temperature",
      intlId: TStatusDisplayId["EnteringWaterTemperature"],
      type: "data"
    },
    {
      title: "Leaving Water Temperature",
      intlId: TStatusDisplayId["LeavingWaterTemperature"],
      type: "data"
    },
    {
      title: "Status",
      intlId: TStatusDisplayId["Status"],
      type: "data"
    },
  ],
};
